import React, { ReactNode } from 'react';
import Typography from '@mui/material/Typography';
import type { TypographyProps } from '@mui/material/Typography';
import type { Theme } from '@mui/material/styles';

/*
   Simple wrapper for Typography component to prevent having to declare
   the same properties everywhere and allow some customization.
*/

interface TypographyErrorProps extends TypographyProps {
  children: ReactNode;
}

function TypographyError({ children, ...other }: TypographyErrorProps) {
  return (
    <Typography
      variant="subtitle1"
      sx={{ color: (theme: Theme) => theme.palette.error.main }}
      {...other}
    >
      {children}
    </Typography>
  );
}

export default TypographyError;
